import {
  CameraZoneField,
  SpecialZoneType,
  ZONE_TYPE_CONFIGS,
} from '@hakimo-ui/hakimo/ui-elements';

export const ALARM_DETAIL_POLL_INTERVAL = 3000;

/** Step (ms) used by the timeline rewind/forward seek buttons on a single, double and triple click */
export const SEEK_STEP_MS = 5000;
export const SEEK_STEP_DOUBLE_MS = 15_000;
export const SEEK_STEP_TRIPLE_MS = 30_000;
export const MULTI_CLICK_WINDOW_MS = 400;

export const ZOOM_CONFIG = {
  /** Minimum visible duration in ms (max zoom-in limit) */
  MIN_VISIBLE_DURATION_MS: 10_000,
  /** Fraction of visible range to zoom per scroll tick */
  SCROLL_ZOOM_FACTOR: 0.05,
  /** Sensitivity multiplier for click-and-drag panning */
  DRAG_PAN_SENSITIVITY: 1.0,
  /** Maximum visual/fetch extension (ms) per side per auto-load action */
  AUTO_LOAD_FETCH_WINDOW_MS: 60_000,
  /** Delay (ms) after the last scroll-out tick before firing the auto-load fetch */
  AUTO_LOAD_FETCH_DEBOUNCE_MS: 250,
  /** Hard cap (ms) on how far neighbour alarms may be fetched on each side
   *  of the original alarm group bounds. */
  MAX_NEIGHBOUR_OFFSET_MS: 15 * 60_000,
};

export const PENDING_COUNT_REFRESH_INTERVAL = 2000;
// SCAN frames: gaps up to this play through (the last frame is held on-screen);
// larger gaps are skipped by the clock. The timeline bridges sub-threshold gaps to
// match — so the two stay in agreement off this single value.
export const SCAN_GAP_SKIP_MS = 2000;
export const MIN_CAMERA_BOX_WIDTH = 400;
export const TIMELINE_HEIGHT = 12;
export const COMPRESSED_TIMELINE_HEIGHT = 40;
export const HOVER_MARGIN_TOP = 24;

export const ZONE_OVERLAY_OPTIONS: Array<{
  id: SpecialZoneType;
  name: string;
  iconColor: string;
  cameraField: CameraZoneField;
}> = ZONE_TYPE_CONFIGS.map(({ type, overlayName, iconColor, cameraField }) => ({
  id: type,
  name: overlayName,
  iconColor,
  cameraField,
}));

export const AlarmPreloaderConfiguration = {
  showWindowDurationInSec: process.env['NX_PUBLIC_SHOW_WINDOW_DURATION_IN_SEC']
    ? parseInt(process.env['NX_PUBLIC_SHOW_WINDOW_DURATION_IN_SEC'])
    : 10,
  preloadWindowDurationInSec: process.env[
    'NX_PUBLIC_PRELOAD_WINDOW_DURATION_IN_SEC'
  ]
    ? parseInt(process.env['NX_PUBLIC_PRELOAD_WINDOW_DURATION_IN_SEC'])
    : 30,
};

export const RESOLVED_STATUSES = [
  'resolved',
  'resolved_by_operator',
  'resolved_by_hakimo',
];

export const ESCALATION_OPEN_RESOLUTION = 'escalation_open';
